<template>
  <!--
  <div id="nav">
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
  </div>
  -->
  <router-view />
</template>

<style lang="scss" scoped>
@media (min-width: 1280px) {
  .container {
    max-width: 1280px;
  }
}

#app {
  //  width: 100%;
  //  min-width: 1280px;
  font-family: "Hiragino Kaku Gothic ProN", "メイリオ", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000000;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

html {
  height: 100%;
}

body {
  height: 100%;
  margin: 0;
}
</style>
